import { Link } from "react-router";
import PageContainer from "../components/Common/PageContainer";
import DashboardLayout from "../components/DashboardLayout/DashboardLayout";

export const ComingSoonPage: React.FC = () => {
  return (
    <DashboardLayout>
      <PageContainer maxWidth={false}>
        <div className="flex flex-col justify-center items-center p-5">
          <div className="text-center">
            <h1 className="text-4xl font-medium text-[#1C1790] mb-4">
              Coming soon 🚀
            </h1>
            <p className="text-xl mb-2">
              Cette feature n'est pas encore disponible.
            </p>
            <p className="text-base text-gray-600">
              Nous travaillons activement pour qu'elle voit le jour au plus
              vite. Veuillez prendre contact avec votre administrateur si vous
              pensez que c'est une erreur.
            </p>
            <Link
              to="/"
              className="inline-block mt-4 px-6 py-3 bg-[#1C1790] text-white rounded hover:bg-[#1C1790] transition-colors"
            >
              Retourner à l'accueil
            </Link>
          </div>
        </div>
      </PageContainer>
    </DashboardLayout>
  );
};
